import { PERMISSIONS } from 'shared-permissions';
import { PRODUCT_ROUTES, ORG_GENERAL_SETTINGS, ORG_USERS } from 'constants/routes.js';

const { CHAT_STATS, WORKSPACE_SETTINGS, EDIT_USERS_CHAT, CHAT_MANAGE_STORES, CHAT_SETTINGS, CHAT_CMS_POSTS, CHAT_APP } =
  PERMISSIONS;

const CHAT_ROUTES = [
  {
    title: 'sidebarComponent.chatAppTitle',
    icon: 'home',
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP,
    requiredPermission: CHAT_APP,
    exact: true,
    requiredFeatures: ['chatAgentWebAppEnabled'],
  },
  {
    title: 'sidebarComponent.chatAppChatTitle',
    icon: 'textChat',
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP_CHAT,
    requiredPermission: CHAT_APP,
    requiredFeatures: ['chatAgentWebAppEnabled'],
    numberIndicators: [{
      valueKey: 'unreadChatAgentMessages',
    }],
  },
  {
    title: 'sidebarComponent.chatAppProfileTitle',
    icon: 'userSettings',
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP_PROFILE,
    requiredPermission: CHAT_APP,
    requiredFeatures: ['chatAgentWebAppEnabled'],
  },
  {
    title: 'sidebarComponent.statsTitle',
    icon: 'insights',
    route: PRODUCT_ROUTES.ORG_CHAT_STATS,
    requiredFeatures: ['chatStatsEmbedEnabled'],
    requiredPermission: [CHAT_STATS],
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.chatManageStoresTitle',
    icon: 'storefront',
    route: PRODUCT_ROUTES.ORG_CHAT_MANAGE_STORES,
    requiredPermission: CHAT_MANAGE_STORES,
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.chatManageDepartmentsTitle',
    icon: 'people',
    route: PRODUCT_ROUTES.ORG_CHAT_DEPARTMENTS,
    requiredPermission: CHAT_SETTINGS,
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.chatContactsTitle',
    icon: 'contacts',
    route: PRODUCT_ROUTES.ORG_CHAT_CONTACTS,
    requiredPermission: [EDIT_USERS_CHAT, CHAT_APP],
    requiredFeatures: ['chatAgentWebAppEnabled'],
    allowSuperAdmin: true,
    numberIndicators: [{
      valueKey: 'unreadContactMessages',
    }],
  },
  {
    title: 'sidebarComponent.chatCmsPostsTitle',
    icon: 'stickyNote',
    route: PRODUCT_ROUTES.ORG_CHAT_CMS_POSTS,
    requiredPermission: CHAT_CMS_POSTS,
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.settingsTitle',
    icon: 'settings',
    align: 'bottom',
    submenu: [
      {
        title: 'sidebarComponent.generalSettingsTitle',
        route: ORG_GENERAL_SETTINGS,
        requiredFeatures: [],
        requiredPermission: WORKSPACE_SETTINGS,
      },
      {
        title: 'sidebarComponent.usersSettingsTitle',
        route: ORG_USERS,
        requiredFeatures: [],
        requiredPermission: EDIT_USERS_CHAT,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.chatStoreAppConfigTitle',
        route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_STORE_APP,
        requiredPermission: CHAT_SETTINGS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.chatWebPluginConfigTitle',
        route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_PLUGIN,
        requiredPermission: CHAT_SETTINGS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.chatRetailerConfigTitle',
        route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_RETAILER,
        requiredPermission: CHAT_SETTINGS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.chatProductFeedConfigTitle',
        route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_PRODUCT_FEED,
        requiredPermission: CHAT_SETTINGS,
        allowSuperAdmin: true,
      },
    ],
  },
];

export default CHAT_ROUTES;
